/** API route map: URLS.Controller.ClientNote */
export const ClientNote = {
      Name: 'ClientNote/',
      GetAll: 'client-note',
      AddNote: 'add-client-note',
      UpdateClientNote: 'update',
      DeleteClientNote: 'delete',
      ShareClientNote: 'share',
};
